import api from "./api";

export async function fetchPodcastList(params = {}) {
  const response = await api.get("/audio-podcast/podcast-list", { params });
  if (response?.data?.error || (response?.data?.code != null && Number(response.data.code) !== 200)) throw new Error(response?.data?.message || 'Unable to load podcasts.');
  return { payload: response?.data?.dataset?.data || {}, meta: response?.data || {} };
}
